<template>
    <default-item class="romanza_default_item--container" :item="item" :pricing-types="pricingTypes"
                  :layout="priceLayout" tag-location="before-title" hide-denomination></default-item>
</template>

<script lang="ts">
/**
 * Custom component for Romanza menu items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2025-03-31 (1.0.0) (jhoward)
 *      - <chi-default-item> copied to <romanza-default-item>.
 */

import {defineComponent, PropType} from "vue";
import {MENU_ITEM_LAYOUT, MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'romanza-default-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<MENU_ITEM_LAYOUT>,
      default: 'price-inline'
    }
  },
})
</script>

<style scoped>

</style>